module.exports = __webpack_public_path__ + "img/Usuarios.915d763a.svg";